// src/comps/NewBroker.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AppConst from '../apis/appconst';
import { toast } from 'react-toastify';

const NewBroker = ({ item, show, onClose }) => {
  const empty = {
    id: '',
    fname: '',
    lname: '',
    dob: '',
    email: '',
    mobile: '',
    address: '',
    lab_commission_type: 'fixed',
    lab_commission: '',
    ipd_commission_type: 'fixed',
    ipd_commission: ''
  };

  const [form, setForm] = useState(empty);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (item) {
      setForm({
        id: item.id || '',
        fname: item.fname || '',
        lname: item.lname || '',
        dob: item.dob || '',
        email: item.email || '',
        mobile: item.mobile || '',
        address: item.address || item.address_line1 || '',
        lab_commission_type: item.lab_commission_type || 'fixed',
        lab_commission: item.lab_commission !== undefined ? item.lab_commission : '',
        ipd_commission_type: item.ipd_commission_type || 'fixed',
        ipd_commission: item.ipd_commission !== undefined ? item.ipd_commission : ''
      });
    } else {
      setForm(empty);
    }
  }, [item, show]);

  const close = () => {
    onClose(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const fd = new FormData();
      if (form.id) fd.append('id', form.id + '');
      fd.append('fname', form.fname);
      fd.append('lname', form.lname || '');
      fd.append('dob', form.dob || '');
      fd.append('email', form.email || '');
      fd.append('mobile', form.mobile || '');
      fd.append('address', form.address || '');

      fd.append('lab_commission_type', form.lab_commission_type);
      fd.append('lab_commission', form.lab_commission || 0);
      fd.append('ipd_commission_type', form.ipd_commission_type);
      fd.append('ipd_commission', form.ipd_commission || 0);

      const res = await axios.post(AppConst.BASE_URL + AppConst.addBrokerUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (res.data && res.data.status) {
        toast.success(res.data.success || 'Broker saved');
        onClose(true);
      } else {
        toast.error(res.data?.success || 'Save failed');
      }
    } catch (err) {
      console.error('save broker error', err);
      toast.error('Save failed');
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal fade show" style={{ display: 'block' }}>
      <div className="modal-dialog modal-lg">
        <form onSubmit={handleSubmit} className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{form.id ? 'Edit Broker' : 'Add Broker'}</h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={close}></button>
          </div>
          <div className="modal-body">
            <div className="row g-2">
              <div className="col-md-6">
                <label className="form-label">First name</label>
                <input className="form-control" value={form.fname} onChange={(e) => setForm(f => ({ ...f, fname: e.target.value }))} required />
              </div>
              <div className="col-md-6">
                <label className="form-label">DOB</label>
                <input className="form-control" type="date" value={form.dob} onChange={(e) => setForm(f => ({ ...f, dob: e.target.value }))} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Email</label>
                <input className="form-control" type="email" value={form.email} onChange={(e) => setForm(f => ({ ...f, email: e.target.value }))} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Phone</label>
                <input className="form-control" value={form.mobile} onChange={(e) => setForm(f => ({ ...f, mobile: e.target.value }))} />
              </div>
              <div className="col-md-12">
                <label className="form-label">Address</label>
                <textarea className="form-control" rows="2" value={form.address} onChange={(e) => setForm(f => ({ ...f, address: e.target.value }))} />
              </div>

              <hr className="my-2" />
              <div className="col-md-6">
                <label className="form-label">Lab Commission Type</label>
                <select className="form-select" value={form.lab_commission_type} onChange={(e) => setForm(f => ({ ...f, lab_commission_type: e.target.value }))}>
                  <option value="fixed">Fixed</option>
                  <option value="percentage">Percentage</option>
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label">Lab Commission</label>
                <input className="form-control" value={form.lab_commission} onChange={(e) => setForm(f => ({ ...f, lab_commission: e.target.value }))} placeholder="Amount or percentage" />
              </div>

              <div className="col-md-6">
                <label className="form-label">IPD Commission Type</label>
                <select className="form-select" value={form.ipd_commission_type} onChange={(e) => setForm(f => ({ ...f, ipd_commission_type: e.target.value }))}>
                  <option value="fixed">Fixed</option>
                  <option value="percentage">Percentage</option>
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label">IPD Commission</label>
                <input className="form-control" value={form.ipd_commission} onChange={(e) => setForm(f => ({ ...f, ipd_commission: e.target.value }))} placeholder="Amount or percentage" />
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={close}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Saving...' : (form.id ? 'Update Broker' : 'Add Broker')}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewBroker;
